import { Component, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from '../../cfet-core';

@Component({
    selector: 'app-load-spinner',
    templateUrl: './load-spinner.component.html',
    styleUrls: ['./load-spinner.component.scss'],
    standalone: false
})
export class LoadSpinnerComponent {
  loading: boolean;

  constructor(private loaderService: LoaderService, private cdRef: ChangeDetectorRef) {
    this.loaderService.isLoading.subscribe((v) => {
      this.loading = v;
      // refresh this view directly so the spinner reflects state changes fired from callers outside this component's CD cycle
      this.cdRef.detectChanges();
    });
  }

}
